export default __webpack_public_path__ + "static/media/elec.2a2bedb8.svg";